import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
import { baseUrl } from '../utils/env';

/**
 * 登陆
 */
export const loginIn = (data) => {
  return fetch(baseUrl + '/api/user/login/', data, 'POST');
};


/**
 * 注册
 */
export const signUp = (data) => {
  return fetch(baseUrl + '/api/user/register/', data, 'POST');
};

/**
 * 获取用户信息
 */
export const ajaxUserInfo = (data) => {
  return fetch(baseUrl + '/api/user/info/', data, 'GET');
};
/**
 * 获取用户日志
 */
export const ajaxServiceList = (data) => {
  return fetch(baseUrl + '/api/user/getService/', data, 'GET');
};
/**
 * 获取用户费率
 */
export const ajaxRate = (data) => {
  return fetch(baseUrl + '/api/user/getServiceRate/', data, 'GET');
};
/**
 * 获取服务
 */
export const ajaxProfileList = (data) => {
  return fetch(baseUrl + '/api/user/getProfile/', data, 'GET');
};
/**
 * 退出
 */
export const ajaxLogout = (data) => {
  return fetch(baseUrl + '/api/user/logout/', {}, 'POST');
};
/**
 * ccd信息
 */
export const ajaxCCDInfo = (data) => {
  return fetch(baseUrl + '/api/ccd/getCCDInfo/');
};
/**
 * 宽带详情
 */
export const ajaxBandwidthDetail = (data) => {
  return fetch(baseUrl + '/api/ccd/ajaxBandwidthDetail/', data);
};